import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';
import { CartasMenusListPage } from '../../cartas-menus-list/cartas-menus-list';
import { ComboServices } from '../../../combo/services';
import { ComboCreateDishSelectPage } from '../../../combo/combo-create/combo-create-dish-select/combo-create-dish-select';
import { ComboCreateTitlePage } from '../../../combo/combo-create/combo-create-title/combo-create-title';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ComboCreatePricePage } from '../../../combo/combo-create/combo-create-price/combo-create-price';
import moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ComboCreateSelectTemplatePage } from '../../../combo/combo-create/combo-create-select-template/combo-create-select-template';
import { ComboCreateImagePage } from '../../../combo/combo-create/combo-create-image/combo-create-image';
import { ComboViewSimulatorPage } from '../../../combo/combo-view/combo-view-simulator/combo-view-simulator';

/**
 * Generated class for the ComponentMenuViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'component-combo-view',
    templateUrl: 'component-combo-view.html',
})
export class ComponentComboViewPage implements OnInit {

    @Input() state: string = "view";
    @ViewChild('enlacesComboContainer') enlacesComboContainer: ElementRef;
    colors: any;
    total_views = 0;
    total_shares = 0;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        private menuServices: MenuServices,
        public globals: Globals,
        public alertCtrl: AlertController,
        public comboServices: ComboServices,
        public toastCtrl: ToastController,
        public http: HttpClient) {
    }

    ngOnInit() {
        this.getViewsShares();
        //al hacer cualquier click cambiar el estado de "new" a "view"
        const container = this.enlacesComboContainer.nativeElement;
        container.addEventListener('click', (event) => {
            this.state = "view";
        });
        //init colors
        this.colors = this.globals.getColorsElements();
    }

    ngOnDestroy() {
        //al destruir componente cambiar el estado de "new" a "view"
        if (this.state === 'new') {
            this.state = "view";
        }
    }

    createSection() {
        this.navCtrl.push(ComboCreateDishSelectPage, {
            type: this.menuServices.menu_tmp.style,
            section: Object.keys(this.menuServices.menu_tmp.sections).length,
            section_complete: this.menuServices.menu_tmp.sections,
            update: true,
            combo_uid: this.menuServices.menu_tmp.UID,
            menu: this.menuServices.menu_tmp,
            new: true,
            combo_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
            show_prices: false
        });
    }

    editName() {
        this.navCtrl.push(ComboCreateTitlePage, {
            type: this.menuServices.menu_tmp.style,
            update: true,
            combo_uid: this.menuServices.menu_tmp.UID,
            template_name: this.menuServices.menu_tmp.template_name,
            tags: this.menuServices.menu_tmp.tags,
            title_es: this.menuServices.menu_tmp.title_es,
            title_ca: this.menuServices.menu_tmp.title_ca,
            title_en: this.menuServices.menu_tmp.title_en,
            title_de: this.menuServices.menu_tmp.title_de,
            title_it: this.menuServices.menu_tmp.title_it,
            title_fr: this.menuServices.menu_tmp.title_fr,
            subtitle_es: this.menuServices.menu_tmp.subtitle_es,
            subtitle_ca: this.menuServices.menu_tmp.subtitle_ca,
            subtitle_en: this.menuServices.menu_tmp.subtitle_en,
            subtitle_de: this.menuServices.menu_tmp.subtitle_de,
            subtitle_it: this.menuServices.menu_tmp.subtitle_it,
            subtitle_fr: this.menuServices.menu_tmp.subtitle_fr,
            reference: this.menuServices.menu_tmp.reference,
            combo_name: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp),
        });
    }

    editSection(index) {
        this.navCtrl.push(ComboCreateDishSelectPage, {
            type: this.menuServices.menu_tmp.style,
            section: index,
            section_complete: this.menuServices.menu_tmp.sections,
            update: true,
            combo_uid: this.menuServices.menu_tmp.UID,
            menu: this.menuServices.menu_tmp,
            new: false,
            combo_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
            show_prices: false
        });
    }

    editPrice() {
        this.navCtrl.push(ComboCreatePricePage, {
            update: true,
            combo_uid: this.menuServices.menu_tmp.UID,
            price: this.menuServices.menu_tmp.price,
            price_takeaway: this.menuServices.menu_tmp.price_takeaway,
            extra_price: this.menuServices.menu_tmp.extra,
            footer: this.menuServices.menu_tmp.footer,
            type: this.menuServices.menu_tmp.style,
            combo_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
        });
    }

    deleteSection(index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-seccion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //delete
                        delete this.menuServices.menu_tmp.sections[index];
                        //reordenar
                        var obj_help = {};
                        var i = 0;
                        for (let item of this.globals.objectToArray(this.menuServices.menu_tmp.sections)) {
                            obj_help[i] = item;
                            i++;
                        }
                        //update
                        this.menuServices.menu_tmp.sections = obj_help;

                        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
                            'sections': this.menuServices.menu_tmp.sections,
                        });
                        this.menuServices.edit = false;
                    }
                }
            ]
        });
        alert.present();
    }

    deleteCombo() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-combo'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Combo', 'Combo - Delete', this.globals.restaurant.email, 'Delete', 'Delete combo', 'Combo', this.menuServices.menu_tmp.UID);
                        this.menuServices.combos_array.splice(this.menuServices.combos_array.findIndex(item => item.UID == this.menuServices.menu_tmp.UID), 1);
                        this.comboServices.valueChanges.unsubscribe();
                        this.menuServices.delete(this.menuServices.menu_tmp.UID);
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }

    async redirect() {
        await this.globals.delay(1000);
        this.navCtrl.setRoot(CartasMenusListPage);
    }

    reorderSections(indexes) {
        let element = this.menuServices.sections_array_tmp[indexes.from];
        this.menuServices.sections_array_tmp.splice(indexes.from, 1);
        this.menuServices.sections_array_tmp.splice(indexes.to, 0, element);
    }

    updateSectionOrder() {
        var _obj = {};
        for (var i = 0; this.menuServices.sections_array_tmp.length > i; i++) {
            _obj[i] = {
                name: this.menuServices.sections_array_tmp[i].name || '',
                name_ca: this.menuServices.sections_array_tmp[i].name_ca || '',
                name_de: this.menuServices.sections_array_tmp[i].name_de || '',
                name_en: this.menuServices.sections_array_tmp[i].name_en || '',
                name_fr: this.menuServices.sections_array_tmp[i].name_fr || '',
                name_it: this.menuServices.sections_array_tmp[i].name_it || '',
                order: i,
                dish: this.menuServices.sections_array_tmp[i].dish,
                combo_cost_extra: this.menuServices.sections_array_tmp[i].combo_cost_extra || false,
                combo_select_multi: this.menuServices.sections_array_tmp[i].combo_select_multi || false,
                combo_required: this.menuServices.sections_array_tmp[i].combo_required || false
            };
        }
        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
            'sections': _obj,
        });

        //toast guardado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    setBackgroundColor(combo) {
        return {
            'background-color': combo.pos_background_color,
            'border': '1px solid ' + combo.pos_border_color,
            'margin-left': '9px',
        }
    }

    setColor(color) {
        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
            pos_background_color: color.pos_background_color,
            pos_border_color: color.pos_border_color,
            pos_color_name: color.name
        });
        document.getElementById('collapseComboColor').classList.remove('show');
        document.getElementById('comboColor').classList.add('collapsed');
    }

    updateOptions() {
        if (this.menuServices.menu_tmp.tpv_active == undefined) {
            this.menuServices.menu_tmp.tpv_active = true;
        }
        if (this.menuServices.menu_tmp.pos_favourite == undefined) {
            this.menuServices.menu_tmp.pos_favourite = false;
        }
        if (this.menuServices.menu_tmp.digital_app == undefined) {
            this.menuServices.menu_tmp.digital_app = false;
        }
        if (this.menuServices.menu_tmp.tk_active == undefined) {
            this.menuServices.menu_tmp.tk_active = false;
        }
        if (this.menuServices.menu_tmp.order_share == undefined) {
            this.menuServices.menu_tmp.order_share = 0;
        }

        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
            tpv_active: this.menuServices.menu_tmp.tpv_active,
            pos_favourite: this.menuServices.menu_tmp.pos_favourite,
            digital_app: this.menuServices.menu_tmp.digital_app,
            tk_active: this.menuServices.menu_tmp.tk_active,
            order_share: this.menuServices.menu_tmp.order_share
        });

        //toast guardado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    license() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    async getViewsShares() {
        const params = new HttpParams()
            .set('rest_uid', this.globals.restaurant_uid)
            .set('first_date', moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .set('last_date', moment().format('YYYY-MM-DD HH:mm:ss'))
            .set('element_uid', this.menuServices.menu_tmp.UID);

        this.http.post(this.globals.analytics_path + 'analytics/total_views_share_element', params, {})
            .subscribe(async response => {
                this.total_views = response['total_views'];
                this.total_shares = response['total_share'];
            });
    }

    selectTemplate() {
        this.navCtrl.push(ComboCreateSelectTemplatePage, {
            update_state: true,
            combo_uid: this.menuServices.menu_tmp.UID,
            template_name: this.menuServices.menu_tmp.template_name,
            combo_name: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp),
        });
    }

    editComboImage() {
        this.navCtrl.push(ComboCreateImagePage, {
            update: true,
            combo_uid: this.menuServices.menu_tmp.UID,
            image: this.menuServices.menu_tmp.image,
            combo_name: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp),
            combo: this.menuServices.menu_tmp
        });
    }

    openAnalytica() {
        this.navCtrl.push(ComboViewSimulatorPage, {
            combo_title: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp)
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/cartas-menus/carta-menu-view/component-combo-view/component-combo-view.ts